let callbackRef = null

const subscribe = (callback, timeout = 500) => {
  setTimeout(() => {
    callbackRef = callback
    document.addEventListener('keydown', keydown)
  }, timeout)
}

const unsubscribe = () => {
  document.removeEventListener('keydown', keydown)
  callbackRef = null
}

const keydown = (event) => {
  if (event.key !== 'Enter') {
    return
  }
  if (!callbackRef) {
    return
  }
  callbackRef()
}

export { subscribe, unsubscribe }
